import { moneyValidator } from "@/utils/validate";

export default {
    computed: {
        detailRule() {
            return {
                name:[{ required: true, message: "请填写名称", trigger: "change" }],
                code:[{ required: true, message: "请填写品番号", trigger: "change" }],
                amount: [
                    { required: true, message: "请填写单价", trigger: "change" },
                    { validator: moneyValidator, trigger: "change" },
                ],
                count: [
                    { required: true, message: "请填写数量", trigger: "change" },
                    {
                        validator: function (rule, value, callback) {
                            let n = parseInt(value);
                            if (isNaN(n) || n === 0) {
                                callback(new Error("请输入正确的数量"));
                            }
                            callback();
                        },
                        trigger: "change",
                    },
                ],
            }
        },
        dataRule() {
            return {
                code:[{ required: true, message: "请填写合同编号", trigger: "change" }],
                customerId:[{
                    required: true,
                    message: this.$t("validate.required"),
                    trigger: "change",
                }],
                currency:[{
                    required: true,
                    message: this.$t("validate.required"),
                    trigger: "change",
                }],
                totalAmount: [
                    {
                        required: true,
                        message: this.$t("validate.required"),
                        trigger: "change",
                    },
                    { validator: moneyValidator, trigger: "change" },
                ],
            };
        },
    }
}